<flx-modal class="ai-feedback-modal dark text-white bg-neutral-800">
  <div class="ai-feedback-modal__body !flex-col">
    <h1 class="text-2xl font-bold text-center">Additional Feedback</h1>
    <h3 class="text-center text-neutral-400">
      Let us know what we can improve about the response:
    </h3>

    <div class="w-full mt-4">
      <div class="flex w-full">
        <flx-label class="grow !font-semibold flx-ds">Select an issue</flx-label>
      </div>
      <flx-choice-group
        [direction]="'column'"
        class="flex w-full mt-1 flx-ds ai-feedback-modal__reasons"
      >
        <flx-radio
          *ngFor="let reason of feedbackReasons"
          [clear]="true"
          [value]="reason"
          [formControl]="$any(feedbackFG.get('reason'))"
          [checked]="feedbackFG.get('reason').value === reason"
        >
          <flx-label>{{ reason }}</flx-label>
        </flx-radio>
      </flx-choice-group>
    </div>

    <flx-textarea class="flx-ds flex w-full mt-4">
      <div class="flex w-full">
        <flx-label class="grow !font-semibold flx-ds mb-1">Extra details (optional)</flx-label>
      </div>

      <textarea
        [formControl]="$any(feedbackFG.get('message'))"
        class="w-full"
        placeholder="Add feedback..."
        flxTextarea
        type="text"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
        cdkAutosizeMaxRows="3"
      ></textarea>
    </flx-textarea>

    <div
      class="ai-feedback-modal__footer w-full mt-3 flex flex-row justify-end items-center gap-3 text-sm font-semibold"
    >
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        flxButton
      >
        Cancel
      </button>
      <button
        [disabled]="feedbackFG.invalid"
        (click)="submitFeedback()"
        class="flx-ds primary"
        flxButton
      >
        Send Feedback
      </button>
    </div>
  </div>
</flx-modal>
